import moment from "moment";
import { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const AppCalander = (props) => {
  const { isCalendar, today, updateToday } = props;
  const [applyData, setApplyData] = useState([new Date()]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const heandelApplyBtn = () => {
    updateToday(applyData);
  };

  const handelCalanderBtn = (val) => {
    const getDay = moment().startOf(val).toLocaleString();
    updateToday([getDay, new Date()]);
  };

  return (
    <div>
      <div id={isCalendar ? "show_modal" : "hide_modal"} class="calendar_modal">
        <div class="calendar_modal_content">
          <div class="calendar_modal_btn_container">
            <button class="pointer" onClick={() => handelCalanderBtn("today")}>
              Today
            </button>
            <button class="pointer" onClick={() => handelCalanderBtn("week")}>
              This Week
            </button>
            <button class="pointer" onClick={() => handelCalanderBtn("month")}>
              This Month
            </button>
          </div>
          <Calendar
            className="react-calendar "
            // value={today}
            defaultValue={new Date()}
            next2Label={null}
            prev2Label={null}
            showNeighboringMonth={false}
            maxDate={new Date()}
            showDoubleView={windowWidth > 700 ? true : false}
            formatMonthYear={(locale, date) =>
              date.toLocaleString(locale, { month: "short", year: "2-digit" })
            }
            onChange={(value, e) => setApplyData(value, e)}
            selectRange={true}
            showFixedNumberOfWeeks={true}
            formatShortWeekday={(locale, value) =>
              ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"][value.getDay()]
            }
          />
          <div className="calendar_modal_bottom text_btn">
            <button onClick={heandelApplyBtn} className=" pointer">
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppCalander;
